export const BROWSE_SHELF_INSTANCES_LIMIT = 25;
